/* @Author: liwen 
 * @Date: 2020-12-Su 05:05:45 
 * @Last Modified by:   liwen  */
import React from 'react';
import { Timeline } from 'antd';
import { connect } from 'react-redux';

class FlowRecords extends React.Component{
    constructor(props){
        super(props);
        this.state = {

        }
    }
    render(){
        let newSecondSelectColor = this.props.config && this.props.config.getValueByKey ? this.props.config.getValueByKey("newSecondSelectColor", '#0050B3') : '#0050B3';
        return(
            <div className="flow-records history-records">
                  <Timeline className="flow-records-timeline history-records-timeline">
                    <Timeline.Item dot={<div className="dots" style={{ background: newSecondSelectColor}}>1</div>}>
                            <span>开始：2020-12-25 16:20:19</span>
                            <span>待处理</span>
                            <span>候选人：王喜颐</span>
                            <span>写稿人</span>
                    </Timeline.Item>
                    <Timeline.Item dot={<div className="dots" style={{ background: newSecondSelectColor}}>1</div>}>
                            <span>开始：2020-12-25 16:20:19</span>
                            <span>待处理</span>
                            <span>候选人：王喜颐</span>
                            <span>副部长：保存为协同稿件</span>
                    </Timeline.Item>
                    <Timeline.Item dot={<div className="dots" style={{ background: newSecondSelectColor}}>1</div>}>
                            <span>开始：2020-12-25 16:20:19</span>
                            <span>待处理</span>
                            <span>候选人：王喜颐</span>
                            <span>副部长：保存为协同稿件</span>
                    </Timeline.Item>
                </Timeline>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return{
        config : state.systemReducer.config
    }
}

export default connect(mapStateToProps)(FlowRecords)
